const MA = [
    {id: "5", value: "5日"},    
    {id: "20", value: "20日"},
    {id: "60", value: "60日"},
    {id: "100", value: "100日"}
  ];  
  
  export default MA  